<template>
  <div
    class="external-form"
    :class="{ light: switchValue, dark: !switchValue }"
  >
    <!-- <header class="ut-fc header">
      <div class="top-bar">
        <div class="top-bar-inner">
          <div class="logo">
            <div class="logo-box">
              <img
                class="img-responsive company-logo"
                :src="`https://detailss3web.s3.amazonaws.com/images/logo/${this.clientName}logo`"
                alt
              />
            </div>
          </div>

          <SwitchButton @switchValueChanged="onChangeSwitchValue()" />

          <div class="language-box">
            <Dropdown
              :showLabel="false"
              :options="languagesTV"
              :selected="languagesTV.find((e) => e.value == language)"
              v-on:selectedChange="(e) => onLanguageChange(e)"
              :style="{
                color: 'white',
              }"
            ></Dropdown>
          </div>
        </div>
      </div>
      <div class="page-header-inner">
        <div class="page-header" v-if="questionnaire != null">
          <span class="page-titile"
            >{{ questionnaire.cdate.start_date || " " }}
            {{ questionnaire.venue.booking_location_name || " " }}
            {{ artistNames || " " }}
          </span>

          <div class="buton-group v1">
            <button
              class="dt-button v1"
              v-if="!submitButtonFlag"
              @click="onSubmit"
            >
              {{ $t("submit") }}
            </button>
            <span v-else>Your data has succesfully been transferred</span>
          </div>
        </div>
      </div>
    </header> -->
    <!-- Replaces the Header component above with a Reusable Component -->
    <!-- Uses the event handlers -->
    <ExternalFormHeader
      :clientName="clientName"
      :language="language"
      :languagesTV="languagesTV"
      :submitButtonFlag="submitButtonFlag"
      @switchValueChanged="onChangeSwitchValue"
      @languageChanged="onLanguageChange"
      @submit="onSubmit"
    >
      <template #pageTitle>
        <span class="page-titile" v-if="questionnaire != null"
          >{{ questionnaire.cdate.start_date || " " }}
          {{ questionnaire.venue.booking_location_name || " " }}
          {{ artistNames || " " }}
        </span>
      </template>
    </ExternalFormHeader>

    <div class="container">
      <!-- {{questionnaire}} -->
      <!-- <div class="dt-box--row"></div> -->
      <div class="questionnaire-row exform-row">
        <div class="questionnaire-evtrav">
          <div class="dt-box--column">
            <div
              class="dt-modal--subtitle ut-mt-0 ut-mb-10px ut-text-secondary ut-font-capitalize"
            >
              Event infos
            </div>

            <BasicAccordion
              v-if="questionnaire != null"
              :accortionTitle="$t('event_details')"
              :validationIconName="
                Object.values(this.eventDetailsValidationResult).every(
                  (e) => e.valid
                )
                  ? 'textbox-complete.svg'
                  : 'textbox-incomplete.svg'
              "
              :class="{ opened: openedState }"
              :expandState="event_detailsExpandState"
              :isLocked="isEventDetailsLocked"
              @clicked="(e) => onShowAccordion('event_details', e)"
            >
              <div
                class="form-group"
                v-if="
                  questionnaire &&
                  questionnaire.rs &&
                  questionnaire.rs.calendar_date
                "
              >
                <TextField
                  v-if="
                    is1(questionnaire.rs.calendar_date['Event Name'].question)
                  "
                  :id="'date_name'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.cdate.date_name"
                  :placeholder="$t('rs_event_name')"
                  @valuechanged="onTextFieldEventValueChange"
                  @validated="onEventDetailsValidation"
                  :required="calendar_dateRequired('Event Name')"
                  :showValidationIcons="calendar_dateRequired('Event Name')"
                  :disabled="isEventDetailsLocked"
                  immediateValidation
                />
                <TextField
                  v-if="
                    is1(questionnaire.rs.calendar_date['Event URL'].question)
                  "
                  :id="'event_url'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.cdate.event_url"
                  :placeholder="$t('event_url')"
                  @valuechanged="onTextFieldEventValueChange"
                  @validated="onEventDetailsValidation"
                  :required="calendar_dateRequired('Event URL')"
                  :showValidationIcons="calendar_dateRequired('Event URL')"
                  :disabled="isEventDetailsLocked"
                  immediateValidation
                />

                <TextField
                  v-if="is1(questionnaire.rs.calendar_date['Line Up'].question)"
                  :id="'lineup'"
                  class="m1"
                  v-bind="textAreaConfig"
                  :value="questionnaire.cdate.lineup"
                  :placeholder="$t('ques_lineup')"
                  :height="142"
                  @valuechanged="onTextFieldEventValueChange"
                  @validated="onEventDetailsValidation"
                  :required="calendar_dateRequired('Line Up')"
                  :showValidationIcons="calendar_dateRequired('Line Up')"
                  :disabled="isEventDetailsLocked"
                  immediateValidation
                />

                <TextField
                  v-if="is1(questionnaire.rs.calendar_date.Doors.question)"
                  :id="'doors_open'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.cdate.doors_open"
                  :placeholder="$t('doors_open')"
                  @valuechanged="onTextFieldEventValueChange"
                  @validated="onEventDetailsValidation"
                  :required="calendar_dateRequired('Doors')"
                  :showValidationIcons="calendar_dateRequired('Doors')"
                  :disabled="isEventDetailsLocked"
                  immediateValidation
                />

                <TextField
                  v-if="is1(questionnaire.rs.calendar_date.Curfew.question)"
                  :id="'curfew'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.cdate.curfew"
                  :placeholder="$t('curfew')"
                  @valuechanged="onTextFieldEventValueChange"
                  @validated="onEventDetailsValidation"
                  :required="calendar_dateRequired('Curfew')"
                  :showValidationIcons="calendar_dateRequired('Curfew')"
                  :disabled="isEventDetailsLocked"
                  immediateValidation
                />

                <div
                  v-for="eventField of questionnaire.event_fields"
                  :key="eventField.custom_data_id"
                >
                  <TextField
                    v-if="
                      questionnaire &&
                      questionnaire.rs &&
                      questionnaire.rs.calendar_date &&
                      questionnaire.rs.calendar_date[eventField.field_label] &&
                      is1(
                        questionnaire.rs.calendar_date[eventField.field_label]
                          .question
                      )
                    "
                    :id="eventField.field_label"
                    class="m1"
                    v-bind="textFieldConfig"
                    :value="eventField.data"
                    :placeholder="`${$dft.capSnake(eventField.field_label)}`"
                    @valuechanged="
                      (name, value) =>
                        onEventFieldsUpdate(name, value, eventField)
                    "
                    @validated="
                      (name, value) =>
                        onEventFieldValidation(name, value, eventField)
                    "
                    :required="calendar_dateRequired(eventField.field_label)"
                    :disabled="isEventDetailsLocked"
                    :showValidationIcons="
                      calendar_dateRequired(eventField.field_label)
                    "
                    immediateValidation
                  />
                </div>

                <div class="lock-wrap" v-if="isEventDetailsLocked">
                  <img
                    src="static/icons/lock-closed-grey.svg"
                    class="dt-icon v5 s2 nohover"
                  />
                  <span>{{ $t("questionnaire_locked") }}</span>
                </div>
              </div>
            </BasicAccordion>

            <BasicAccordion
              v-if="questionnaire != null"
              :accortionTitle="$t('location_details')"
              :validationIconName="validationIconVenue"
              :expandState="location_detailsExpandState"
              :isLocked="lockJson.calendar_dates_venue === 'lock'"
              @clicked="(e) => onShowAccordion('location_details', e)"
            >
              <div
                class="form-group"
                v-if="
                  questionnaire &&
                  questionnaire.rs &&
                  questionnaire.rs.booking_location
                "
              >
                <TextField
                  v-if="
                    is1(
                      questionnaire.rs.booking_location['Venue Name'].question
                    )
                  "
                  :id="'booking_location_name'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :placeholder="$t('location_name')"
                  :value="questionnaire.venue.booking_location_name"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  @valuechanged="onVenueTextFieldValueChange"
                />
                <TextField
                  v-if="
                    is1(questionnaire.rs.booking_location.Address1.question)
                  "
                  :id="'address1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.venue.address1"
                  :placeholder="$t('address')"
                  @valuechanged="onVenueTextFieldValueChange"
                  @validated="onVenueDetailsValidation"
                  :required="booking_locationRequired('Address1')"
                  :showValidationIcons="booking_locationRequired('Address1')"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  immediateValidation
                />
                <TextField
                  v-if="
                    is1(questionnaire.rs.booking_location.Address2.question)
                  "
                  :id="'address2'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.venue.address2"
                  :placeholder="$t('address_2')"
                  @valuechanged="onVenueTextFieldValueChange"
                  @validated="onVenueDetailsValidation"
                  :required="booking_locationRequired('Address2')"
                  :showValidationIcons="booking_locationRequired('Address2')"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.booking_location.City.question)"
                  :id="'city'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.venue.city"
                  :placeholder="$t('city')"
                  @valuechanged="onVenueTextFieldValueChange"
                  @validated="onVenueDetailsValidation"
                  :required="booking_locationRequired('City')"
                  :showValidationIcons="booking_locationRequired('City')"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  immediateValidation
                />
                <TextField
                  v-if="
                    is1(questionnaire.rs.booking_location.Postalcode.question)
                  "
                  :id="'postalcode'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.venue.postalcode"
                  :placeholder="$t('postal_code')"
                  @valuechanged="onVenueTextFieldValueChange"
                  @validated="onVenueDetailsValidation"
                  :required="booking_locationRequired('Postalcode')"
                  :showValidationIcons="booking_locationRequired('Postalcode')"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  immediateValidation
                />

                <TextField
                  v-if="is1(questionnaire.rs.booking_location.Country.question)"
                  :id="'country'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.venue.country"
                  :placeholder="$t('country')"
                  @valuechanged="onVenueTextFieldValueChange"
                  @validated="onVenueDetailsValidation"
                  :required="booking_locationRequired('Country')"
                  :showValidationIcons="booking_locationRequired('Country')"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.booking_location.Phone1.question)"
                  :id="'phone1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.venue.phone1"
                  :placeholder="$t('phone')"
                  @valuechanged="onVenueTextFieldValueChange"
                  @validated="onVenueDetailsValidation"
                  :required="booking_locationRequired('Phone1')"
                  :showValidationIcons="booking_locationRequired('Phone1')"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.booking_location.Url.question)"
                  :id="'url1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.venue.url1"
                  :placeholder="$t('url')"
                  @valuechanged="onVenueTextFieldValueChange"
                  @validated="onVenueDetailsValidation"
                  :required="booking_locationRequired('Url')"
                  :showValidationIcons="booking_locationRequired('Url')"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  immediateValidation
                />
                <TextField
                  v-if="
                    is1(questionnaire.rs.booking_location.Capacity.question)
                  "
                  :id="'venue_capacity'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.venue.venue_capacity"
                  :placeholder="$t('capacity')"
                  @valuechanged="onVenueTextFieldValueChange"
                  @validated="onVenueDetailsValidation"
                  :required="booking_locationRequired('Capacity')"
                  :showValidationIcons="booking_locationRequired('Capacity')"
                  :disabled="lockJson.calendar_dates_venue == 'lock'"
                  immediateValidation
                />

                <div
                  v-for="venueField of questionnaire.venue_fields"
                  :key="venueField.field_label || venueField.custom_data_id"
                >
                  <TextField
                    v-if="
                      questionnaire &&
                      questionnaire.rs &&
                      questionnaire.rs.booking_location &&
                      questionnaire.rs.booking_location[
                        venueField.field_label
                      ] &&
                      is1(
                        questionnaire.rs.booking_location[
                          venueField.field_label
                        ].question
                      )
                    "
                    :id="venueField.field_label"
                    class="m1"
                    v-bind="textFieldConfig"
                    :value="venueField.data"
                    :placeholder="`${$dft.capSnake(venueField.field_label)}`"
                    :disabled="lockJson.calendar_dates_venue == 'lock'"
                    @valuechanged="
                      (name, value) =>
                        onVenueFieldsUpdate(name, value, venueField)
                    "
                    @validated="
                      (name, value) =>
                        onVenueFieldValidation(name, value, venueField)
                    "
                    :required="booking_locationRequired(venueField.field_label)"
                    :showValidationIcons="
                      booking_locationRequired(venueField.field_label)
                    "
                    immediateValidation
                  />
                </div>

                <div
                  class="lock-wrap"
                  v-if="lockJson.calendar_dates_venue == 'lock'"
                >
                  <img
                    src="static/icons/lock-closed-grey.svg"
                    class="dt-icon v5 s2 nohover"
                  />
                  <span>{{ $t("questionnaire_locked") }}</span>
                </div>
              </div>
            </BasicAccordion>

            <div v-if="questionnaire != null">
              <div
                v-for="(artist, index) in questionnaire.artists"
                :key="index"
              >
                <!-- <div
                v-if="
                  questionnaire.rs.calendar_date_artist.Offer.question &&
                    artist.confirmed_flag == 1
                "
              >
                Deactivate - no need validation
              </div> -->

                <BasicAccordion
                  :accortionTitle="
                    $t('artist_details') + ': ' + artist.artist_name
                  "
                  :validationIconName="
                    Object.values(
                      artistsValidationResult &&
                        artistsValidationResult[artist.artist_id]
                        ? artistsValidationResult[artist.artist_id]
                        : {}
                    ).every((e) => e.valid)
                      ? 'textbox-complete.svg'
                      : 'textbox-incomplete.svg'
                  "
                  :expandState="artist_detailsExpandState[artist.artist_id]"
                  :isLocked="
                    lockJson[
                      `calendar_date_artists_${artist.calendar_date_artist_id}`
                    ] === 'lock'
                  "
                  @clicked="(e) => onShowAccordionArtist(artist.artist_id, e)"
                >
                  <div
                    class="form-group"
                    v-if="
                      questionnaire &&
                      questionnaire.rs &&
                      questionnaire.rs.calendar_date_artist
                    "
                  >
                    <TextField
                      v-if="
                        is1(
                          questionnaire.rs.calendar_date_artist.Artist.question
                        )
                      "
                      :id="'artist_name'"
                      class="m1"
                      v-bind="textFieldConfig"
                      :value="artist.artist_name"
                      :placeholder="$t('artists')"
                      disabled="disabled"
                    />

                    <TextField
                      v-if="
                        is1(
                          questionnaire.rs.calendar_date_artist.Offer.question
                        )
                      "
                      class="m1"
                      :disabled="
                        lockJson[
                          `calendar_date_artists_${artist.calendar_date_artist_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :id="'first_offer_notes'"
                      v-bind="textFieldConfig"
                      :placeholder="$t('first_offer')"
                      :value="artist.first_offer_notes"
                      @valuechanged="
                        (name, value) =>
                          onArtistTextFieldValueChange(name, value, index)
                      "
                      @validated="
                        (name, value) =>
                          onArtistDetailsValidation(name, value, index, artist)
                      "
                      :required="calendarDateArtistRequired(artist, 'Offer')"
                      :showValidationIcons="
                        calendarDateArtistRequired(artist, 'Offer')
                      "
                      immediateValidation
                    />

                    <TextField
                      v-if="
                        is1(
                          questionnaire.rs.calendar_date_artist.Showtime
                            .question
                        )
                      "
                      class="m1"
                      :disabled="
                        lockJson[
                          `calendar_date_artists_${artist.calendar_date_artist_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :id="'performance_time'"
                      v-bind="textFieldConfig"
                      :placeholder="$t('performance_time')"
                      :value="artist.performance_time"
                      @valuechanged="
                        (name, value) =>
                          onArtistTextFieldValueChange(name, value, index)
                      "
                      @validated="
                        (name, value) =>
                          onArtistDetailsValidation(name, value, index, artist)
                      "
                      :required="calendarDateArtistRequired(artist, 'Duration')"
                      :showValidationIcons="
                        calendarDateArtistRequired(artist, 'Duration')
                      "
                      immediateValidation
                    />

                    <TextField
                      v-if="
                        is1(
                          questionnaire.rs.calendar_date_artist.Duration
                            .question
                        )
                      "
                      class="m1"
                      :disabled="
                        lockJson[
                          `calendar_date_artists_${artist.calendar_date_artist_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :id="'performance_time_contract'"
                      v-bind="textFieldConfig"
                      :placeholder="$t('playtime')"
                      :value="artist.performance_time_contract"
                      @valuechanged="
                        (name, value) =>
                          onArtistTextFieldValueChange(name, value, index)
                      "
                      @validated="
                        (name, value) =>
                          onArtistDetailsValidation(name, value, index, artist)
                      "
                      :required="calendarDateArtistRequired(artist, 'Showtime')"
                      :showValidationIcons="
                        calendarDateArtistRequired(artist, 'Showtime')
                      "
                      immediateValidation
                    />

                    <TextField
                      v-if="
                        is1(
                          questionnaire.rs.calendar_date_artist.Soundcheck
                            .question
                        )
                      "
                      class="m1"
                      :disabled="
                        lockJson[
                          `calendar_date_artists_${artist.calendar_date_artist_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :id="'soundcheck'"
                      v-bind="textFieldConfig"
                      :placeholder="$t('soundcheck')"
                      :value="artist.soundcheck"
                      @valuechanged="
                        (name, value) =>
                          onArtistTextFieldValueChange(name, value, index)
                      "
                      @validated="
                        (name, value) =>
                          onArtistDetailsValidation(name, value, index, artist)
                      "
                      :required="
                        calendarDateArtistRequired(artist, 'Soundcheck')
                      "
                      :showValidationIcons="
                        calendarDateArtistRequired(artist, 'Soundcheck')
                      "
                      immediateValidation
                    />
                    <TextField
                      v-if="
                        is1(
                          questionnaire.rs.calendar_date_artist['Artist Before']
                            .question
                        )
                      "
                      class="m1"
                      :disabled="
                        lockJson[
                          `calendar_date_artists_${artist.calendar_date_artist_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :id="'artist_before'"
                      v-bind="textFieldConfig"
                      :placeholder="$t('artist_before')"
                      :value="artist.artist_before"
                      @valuechanged="
                        (name, value) =>
                          onArtistTextFieldValueChange(name, value, index)
                      "
                      @validated="
                        (name, value) =>
                          onArtistDetailsValidation(name, value, index, artist)
                      "
                      :required="
                        calendarDateArtistRequired(artist, 'Artist Before')
                      "
                      :showValidationIcons="
                        calendarDateArtistRequired(artist, 'Artist Before')
                      "
                      immediateValidation
                    />

                    <TextField
                      v-if="
                        is1(
                          questionnaire.rs.calendar_date_artist['Artist After']
                            .question
                        )
                      "
                      class="m1"
                      :disabled="
                        lockJson[
                          `calendar_date_artists_${artist.calendar_date_artist_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :id="'artist_after'"
                      v-bind="textFieldConfig"
                      :placeholder="$t('artist_after')"
                      :value="artist.artist_after"
                      @valuechanged="
                        (name, value) =>
                          onArtistTextFieldValueChange(name, value, index)
                      "
                      @validated="
                        (name, value) =>
                          onArtistDetailsValidation(name, value, index, artist)
                      "
                      :required="
                        calendarDateArtistRequired(artist, 'Artist After')
                      "
                      :showValidationIcons="
                        calendarDateArtistRequired(artist, 'Artist After')
                      "
                      immediateValidation
                    />

                    <TextField
                      v-if="
                        is1(
                          questionnaire.rs.calendar_date_artist['Stage Floor']
                            .question
                        )
                      "
                      class="m1"
                      :disabled="
                        lockJson[
                          `calendar_date_artists_${artist.calendar_date_artist_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :id="'stage_name'"
                      v-bind="textFieldConfig"
                      :placeholder="$t('stage_floor')"
                      :value="artist.stage_name"
                      @valuechanged="
                        (name, value) =>
                          onArtistTextFieldValueChange(name, value, index)
                      "
                      @validated="
                        (name, value) =>
                          onArtistDetailsValidation(name, value, index, artist)
                      "
                      :required="
                        calendarDateArtistRequired(artist, 'Stage Floor')
                      "
                      :showValidationIcons="
                        calendarDateArtistRequired(artist, 'Stage Floor')
                      "
                      immediateValidation
                    />

                    <div
                      v-for="(artistsField, index) of questionnaire
                        .calendar_date_artists_fields[
                        artist.calendar_date_artist_id
                      ] || []"
                      :key="index"
                    >
                      <template
                        v-if="
                          questionnaire.rs.calendar_date_artist[
                            artistsField.field_label
                          ]
                        "
                      >
                        <TextField
                          v-if="
                            questionnaire &&
                            questionnaire.rs &&
                            questionnaire.rs.calendar_date_artist &&
                            questionnaire.rs.calendar_date_artist[
                              artistsField.field_label
                            ] &&
                            is1(
                              questionnaire.rs.calendar_date_artist[
                                artistsField.field_label
                              ].question
                            )
                          "
                          class="m1"
                          :disabled="
                            lockJson[
                              `calendar_date_artists_${artist.calendar_date_artist_id}`
                            ] == 'lock'
                              ? true
                              : false
                          "
                          :id="artistsField.field_label"
                          v-bind="textFieldConfig"
                          :placeholder="`${$dft.capSnake(
                            artistsField.field_label
                          )}`"
                          :value="artistsField.data"
                          @valuechanged="
                            (name, value) =>
                              onArtistsFieldsUpdate(name, value, artistsField)
                          "
                          @validated="
                            (name, value) =>
                              onArtistsFieldValidation(name, value, artist)
                          "
                          :required="
                            calendarDateArtistRequired(
                              artist,
                              artistsField.field_label
                            )
                          "
                          :showValidationIcons="
                            calendarDateArtistRequired(
                              artist,
                              artistsField.field_label
                            )
                          "
                          immediateValidation
                        />
                      </template>
                    </div>
                    <!-- <div
                      v-for="artistField of artistFields"
                      :key="artistField.custom_data_id"
                    >
                      <TextField
                        v-if="
                          questionnaire &&
                          questionnaire.rs &&
                          questionnaire.rs.promoter &&
                          questionnaire.rs.promoter[
                            artistField.field_label
                          ] &&
                          is1(
                            questionnaire.rs.calendar_date_artist[artistField.field_label]
                              .question
                          )
                        "
                        :id="artistField.field_label"
                        class="m1"
                        v-bind="textFieldConfig"
                        :value="artistField.data"
                        :placeholder="`${$dft.capSnake(
                          artistField.field_label
                        )}`"
                        :disabled="lockJson.calendar_dates_promoter == 'lock'"
                        @valuechanged="
                          (name, value) =>
                            onArtistFieldsUpdate(name, value, artistField)
                        "
                        @validated="
                          (name, value) =>
                            onArtistFieldValidation(
                              name,
                              value,
                              artistField
                            )
                        "
                        :required="promoterRequired(artistField.field_label)"
                        :showValidationIcons="
                          promoterRequired(artistField.field_label)
                        "
                        immediateValidation
                      />
                    </div> -->

                    <div
                      class="lock-wrap"
                      v-if="
                        lockJson[
                          `calendar_date_artists_${artist.calendar_date_artist_id}`
                        ] == 'lock'
                      "
                    >
                      <!-- @click.stop="e => onLockClick(item)" -->
                      <img
                        src="static/icons/lock-closed-grey.svg"
                        class="dt-icon v5 s2 nohover"
                      />
                      <span>{{ $t("questionnaire_locked") }}</span>
                    </div>
                  </div>
                </BasicAccordion>
              </div>
            </div>

            <BasicAccordion
              v-if="questionnaire != null"
              :accortionTitle="$t('contact')"
              :validationIconName="
                Object.values(this.contactDetailsValidationResult).every(
                  (e) => e.valid
                )
                  ? 'textbox-complete.svg'
                  : 'textbox-incomplete.svg'
              "
              :expandState="contactExpandState"
              :isLocked="lockJson.calendar_dates_contact === 'lock'"
              @clicked="(e) => onShowAccordion('contact', e)"
            >
              <div
                class="form-group"
                v-if="
                  questionnaire && questionnaire.rs && questionnaire.rs.contact
                "
              >
                <TextField
                  v-if="is1(questionnaire.rs.contact['First Name'].question)"
                  :id="'first_name'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.first_name"
                  :placeholder="$t('first_name')"
                  @valuechanged="onContactTextFieldValueChange"
                  :disabled="'disabled'"
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact['Last Name'].question)"
                  :id="'last_name'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.last_name"
                  :placeholder="$t('last_name')"
                  @valuechanged="onContactTextFieldValueChange"
                  :disabled="'disabled'"
                />

                <TextField
                  v-if="is1(questionnaire.rs.contact.Address1.question)"
                  :id="'address1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.address1"
                  :placeholder="$t('address')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Address1')"
                  :showValidationIcons="contactRequired('Address1')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact.Address2.question)"
                  :id="'address2'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.address2"
                  :placeholder="$t('address_2')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Address2')"
                  :showValidationIcons="contactRequired('Address2')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact.City.question)"
                  :id="'city'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.city"
                  :placeholder="$t('city')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('City')"
                  :showValidationIcons="contactRequired('City')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact.Postalcode.question)"
                  :id="'postalcode'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.postalcode"
                  :placeholder="$t('postalcode')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Postalcode')"
                  :showValidationIcons="contactRequired('Postalcode')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact.Country.question)"
                  :id="'country'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.country"
                  :placeholder="$t('country')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Country')"
                  :showValidationIcons="contactRequired('Country')"
                  immediateValidation
                />

                <TextField
                  v-if="is1(questionnaire.rs.contact.Phone1.question)"
                  :id="'phone1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.phone1"
                  :placeholder="$t('phone')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Phone1')"
                  :showValidationIcons="contactRequired('Phone1')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact.Phone2.question)"
                  :id="'phone2'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.phone2"
                  :placeholder="$t('mobile')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Phone2')"
                  :showValidationIcons="contactRequired('Phone2')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact.Email1.question)"
                  :id="'email1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.email1"
                  :placeholder="$t('email')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Email1')"
                  :showValidationIcons="contactRequired('Email1')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact.Fax1.question)"
                  :id="'fax1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.fax1"
                  :placeholder="$t('fax')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Fax1')"
                  :showValidationIcons="contactRequired('Fax1')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.contact.Skype.question)"
                  :id="'chat3'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.contact.chat3"
                  :placeholder="$t('skype')"
                  :disabled="lockJson.calendar_dates_contact == 'lock'"
                  @valuechanged="onContactTextFieldValueChange"
                  @validated="onContactDetailsValidation"
                  :required="contactRequired('Skype')"
                  :showValidationIcons="contactRequired('Skype')"
                  immediateValidation
                />
                <div
                  v-for="contactField of questionnaire.contact_fields"
                  :key="contactField.custom_field_id"
                >
                  <TextField
                    v-if="
                      questionnaire.rs &&
                      questionnaire.rs.contact &&
                      questionnaire.rs.contact[contactField.field_label] &&
                      is1(
                        questionnaire.rs.contact[contactField.field_label]
                          .question
                      )
                    "
                    :id="contactField.field_label"
                    class="m1"
                    v-bind="textFieldConfig"
                    :value="contactField.data"
                    :placeholder="`${$dft.capSnake(contactField.field_label)}`"
                    :disabled="lockJson.calendar_dates_contact == 'lock'"
                    @valuechanged="
                      (name, value) =>
                        onContactFieldsUpdate(name, value, contactField)
                    "
                    @validated="
                      (name, value) =>
                        onContactFieldValidation(name, value, contactField)
                    "
                    :required="contactRequired(contactField.field_label)"
                    :showValidationIcons="contactRequired(contactField.field_label)"
                    immediateValidation
                  />
                </div>

                <div
                  class="lock-wrap"
                  v-if="lockJson.calendar_dates_contact == 'lock'"
                >
                  <img
                    src="static/icons/lock-closed-grey.svg"
                    class="dt-icon v5 s2 nohover"
                  />
                  <span>{{ $t("questionnaire_locked") }}</span>
                </div>
              </div>
            </BasicAccordion>

            <BasicAccordion
              v-if="questionnaire != null"
              :accortionTitle="$t('contract_partner_details')"
              :validationIconName="
                Object.values(this.promoterDetailsValidationResult).every(
                  (e) => e.valid
                )
                  ? 'textbox-complete.svg'
                  : 'textbox-incomplete.svg'
              "
              :expandState="contract_partner_detailsExpandState"
              :isLocked="lockJson.calendar_dates_promoter === 'lock'"
              @clicked="(e) => onShowAccordion('contract_partner_details', e)"
            >
              <div
                class="form-group"
                v-if="
                  questionnaire && questionnaire.rs && questionnaire.rs.promoter
                "
              >
                <TextField
                  v-if="
                    is1(questionnaire.rs.promoter['Promoter Name'].question)
                  "
                  :id="'company_name'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.company_name"
                  :placeholder="$t('company_name')"
                  disabled="disabled"
                />
                <TextField
                  v-if="
                    is1(
                      questionnaire.rs.promoter['Legal / Representative']
                        .question
                    )
                  "
                  :id="'company_legalname'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.company_legalname"
                  :placeholder="$t('legal_name')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Legal / Representative')"
                  :showValidationIcons="
                    promoterRequired('Legal / Representative')
                  "
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter.Address1.question)"
                  :id="'address1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.address1"
                  :placeholder="$t('address')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Address1')"
                  :showValidationIcons="promoterRequired('Address1')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter.Address2.question)"
                  :id="'address2'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.address2"
                  :placeholder="$t('address_2')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Address2')"
                  :showValidationIcons="promoterRequired('Address2')"
                  immediateValidation
                />

                <TextField
                  v-if="is1(questionnaire.rs.promoter.City.question)"
                  :id="'city'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.city"
                  :placeholder="$t('city')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('City')"
                  :showValidationIcons="promoterRequired('City')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter.Postalcode.question)"
                  :id="'postalcode'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.postalcode"
                  :placeholder="$t('postal_code')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Postalcode')"
                  :showValidationIcons="promoterRequired('Postalcode')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter.Country.question)"
                  :id="'country'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.country"
                  :placeholder="$t('country')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Country')"
                  :showValidationIcons="promoterRequired('Country')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter.Phone1.question)"
                  :id="'phone1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.phone1"
                  :placeholder="$t('phone')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Phone1')"
                  :showValidationIcons="promoterRequired('Phone1')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter.Phone2.question)"
                  :id="'phone2'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.phone2"
                  :placeholder="$t('mobile')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Phone2')"
                  :showValidationIcons="promoterRequired('Phone2')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter.Email.question)"
                  :id="'email1'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.email1"
                  :placeholder="$t('email')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Email')"
                  :showValidationIcons="promoterRequired('Email')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter['VAT ID'].question)"
                  :id="'vat_no'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.vat_no"
                  :placeholder="$t('vat_id')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('VAT ID')"
                  :showValidationIcons="promoterRequired('VAT ID')"
                  immediateValidation
                />
                <TextField
                  v-if="is1(questionnaire.rs.promoter['Tax No'].question)"
                  :id="'tax_no'"
                  class="m1"
                  v-bind="textFieldConfig"
                  :value="questionnaire.promoter.tax_no"
                  :placeholder="$t('tax_id')"
                  :disabled="lockJson.calendar_dates_promoter == 'lock'"
                  @valuechanged="onPromoterTextFieldValueChange"
                  @validated="onPromoterDetailsValidation"
                  :required="promoterRequired('Tax No')"
                  :showValidationIcons="promoterRequired('Tax No')"
                  immediateValidation
                />

                <div
                  v-for="promoterField of questionnaire.promoter_fields"
                  :key="promoterField.custom_data_id"
                >
                  <TextField
                    v-if="
                      questionnaire &&
                      questionnaire.rs &&
                      questionnaire.rs.promoter &&
                      questionnaire.rs.promoter[promoterField.field_label] &&
                      is1(
                        questionnaire.rs.promoter[promoterField.field_label]
                          .question
                      )
                    "
                    :id="promoterField.field_label"
                    class="m1"
                    v-bind="textFieldConfig"
                    :value="promoterField.data"
                    :placeholder="`${$dft.capSnake(promoterField.field_label)}`"
                    :disabled="lockJson.calendar_dates_promoter == 'lock'"
                    @valuechanged="
                      (name, value) =>
                        onPromoterFieldsUpdate(name, value, promoterField)
                    "
                    @validated="
                      (name, value) =>
                        onPromoterFieldValidation(name, value, promoterField)
                    "
                    :required="promoterRequired(promoterField.field_label)"
                    :showValidationIcons="
                      promoterRequired(promoterField.field_label)
                    "
                    immediateValidation
                  />
                </div>

                <div
                  class="lock-wrap"
                  v-if="lockJson.calendar_dates_promoter == 'lock'"
                >
                  <img
                    src="static/icons/lock-closed-grey.svg"
                    class="dt-icon v5 s2 nohover"
                  />
                  <span>{{ $t("questionnaire_locked") }}</span>
                </div>
              </div>
            </BasicAccordion>

            <BasicAccordion
              v-if="questionnaire != null"
              :accortionTitle="$t('artwork')"
              :expandState="artworkExpandState"
              :validationIconName="'textbox-complete.svg'"
              @clicked="(e) => onShowAccordion('artwork', e)"
            >
              <QuestionnaireArtwork
                :checksum="checksum"
                :promoter_id="promoter_id"
                :clientID="clientName"
                :calendar_date_id="calendar_date_id"
              />
            </BasicAccordion>
          </div>
          <div
            v-if="questionnaire && questionnaire.travels"
            class="dt-box--column"
          >
            <div
              class="dt-modal--subtitle ut-mt-0 ut-mb-10px ut-text-secondary ut-font-capitalize"
            >
              {{ $t("travel_details") }}
            </div>
            <BasicAccordion
              v-if="questionnaire != null"
              :accortionTitle="$t('travel_before')"
              :expandState="travel_beforeExpandState"
              @clicked="(e) => onShowAccordion('travel_before', e)"
              :validationIconName="'textbox-complete.svg'"
            >
              <div v-if="travelBeforeData.length > 0">
                <div
                  class="travel-contaiter"
                  v-for="(item, travel_id) in travelBeforeData"
                  :key="travel_id"
                >
                  <TravelTable :item="item" />
                  <TravelBlock :item="item" />
                </div>
              </div>
              <div v-else>no travel info available</div>
            </BasicAccordion>

            <BasicAccordion
              v-if="questionnaire != null"
              :accortionTitle="$t('travel_after')"
              :expandState="travel_afterExpandState"
              @clicked="(e) => onShowAccordion('travel_after', e)"
              :validationIconName="'textbox-complete.svg'"
            >
              <div v-if="travelAfterData.length > 0">
                <div
                  class="travel-contaiter"
                  v-for="(item, travel_id) in travelAfterData"
                  :key="travel_id"
                >
                  <TravelTable :item="item" />
                  <TravelBlock :item="item" />
                </div>
              </div>
              <div v-else>no travel info available</div>
            </BasicAccordion>
          </div>
        </div>
        <div class="questionnaire-ld">
          <div v-if="localDetailsList.length > 0" class="dt-box--column">
            <div
              class="dt-modal--subtitle ut-mt-0 ut-mb-10px ut-text-secondary ut-font-capitalize"
            >
              {{ $t("local_details") }}
            </div>

            <div v-if="questionnaire != null">
              <BasicAccordion
                v-for="(localDetails, index) of localDetailsList || []"
                :key="index"
                :accortionTitle="localDetails.name"
                :validationIconName="
                  Object.values(
                    localDetailsValidationResult &&
                      localDetailsValidationResult[localDetails.local_detail_id]
                      ? localDetailsValidationResult[
                          localDetails.local_detail_id
                        ]
                      : {}
                  ).every((e) => e.valid)
                    ? 'textbox-complete.svg'
                    : 'textbox-incomplete.svg'
                "
                :expandState="
                  localDetailsExpandState[localDetails.local_detail_id]
                "
                :isLocked="
                  lockJson[`local_details_${localDetails.local_detail_id}`] ===
                  'lock'
                "
                @clicked="
                  (e) =>
                    onShowAccordionLocalDetails(localDetails.local_detail_id, e)
                "
              >
                <div class="form-group">
                  <div
                    v-for="field of localDetails.localDetailsForm"
                    :key="field.name || field.custom_field_id"
                  >
                    <!-- For all built in Fields that are not "notes" - This is a normal textinput   -->
                    <TextField
                      v-if="field.name && field.name != 'notes'"
                      class="m1"
                      :disabled="
                        lockJson[
                          `local_details_${localDetails.local_detail_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :required="
                        lockJson[
                          `local_details_${localDetails.local_detail_id}`
                        ] != 'lock'
                          ? true
                          : false
                      "
                      :id="field.name"
                      v-bind="getLDConditionalConfig(localDetails, field.name)"
                      :value="field.value"
                      :placeholder="`${$dft.capSnake(field.name)}`"
                      :options="
                        localDetails.name == 'Hotel'
                          ? hotelTV
                          : localDetails.name == 'Restaurant'
                          ? restaurantTV
                          : []
                      "
                      @selected="
                        (e) => onLocalDetailsOptionSelected(e, localDetails)
                      "
                      @valuechanged="
                        (name, value) =>
                          onLocalDetailsUpdate(name, value, field, localDetails)
                      "
                      @validated="
                        (name, value) =>
                          onLocalDetailsValidation(
                            name,
                            value,
                            field,
                            localDetails
                          )
                      "
                      showValidationIcons
                      immediateValidation
                    />
                    <!-- If the Built in Local Details Field is "notes" then the Control would be a TextArea -->
                    <TextField
                      v-if="field.name && field.name == 'notes'"
                      class="m1"
                      textarea
                      :height="142"
                      :disabled="
                        lockJson[
                          `local_details_${localDetails.local_detail_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :required="
                        lockJson[
                          `local_details_${localDetails.local_detail_id}`
                        ] != 'lock'
                          ? true
                          : false
                      "
                      :id="field.name"
                      v-bind="getLDConditionalConfig(localDetails, field.name)"
                      :value="field.value"
                      :placeholder="`${$dft.capSnake(field.name)}`"
                      :options="
                        localDetails.name == 'Hotel'
                          ? hotelTV
                          : localDetails.name == 'Restaurant'
                          ? restaurantTV
                          : []
                      "
                      @selected="
                        (e) => onLocalDetailsOptionSelected(e, localDetails)
                      "
                      @valuechanged="
                        (name, value) =>
                          onLocalDetailsUpdate(name, value, field, localDetails)
                      "
                      @validated="
                        (name, value) =>
                          onLocalDetailsValidation(
                            name,
                            value,
                            field,
                            localDetails
                          )
                      "
                      showValidationIcons
                      immediateValidation
                    />
                    <TextField
                      v-if="!field.name"
                      class="m1"
                      :disabled="
                        lockJson[
                          `local_details_${localDetails.local_detail_id}`
                        ] == 'lock'
                          ? true
                          : false
                      "
                      :required="
                        lockJson[
                          `local_details_${localDetails.local_detail_id}`
                        ] != 'lock'
                          ? true
                          : false
                      "
                      :id="field.field_label"
                      v-bind="textFieldConfig"
                      :value="field.data"
                      :placeholder="`${$dft.capSnake(field.field_label)}`"
                      @valuechanged="
                        (name, value) =>
                          onLocalDetailsCustomUpdate(value, field)
                      "
                      @validated="
                        (name, value) =>
                          onLocalDetailsValidation(
                            name,
                            value,
                            field,
                            localDetails
                          )
                      "
                      showValidationIcons
                      immediateValidation
                    />
                  </div>
                  <div
                    class="lock-wrap"
                    v-if="
                      lockJson[
                        `local_details_${localDetails.local_detail_id}`
                      ] == 'lock'
                    "
                  >
                    <img
                      src="static/icons/lock-closed-grey.svg"
                      class="dt-icon v5 s2 nohover"
                    />
                    <!-- <img
                    src="static/icons/lock-closed-white.svg"
                    class="dt-icon v5 s2 nohover dark-mode"
                  /> -->
                    <span>{{ $t("questionnaire_locked") }}</span>
                  </div>
                </div>
              </BasicAccordion>
            </div>
          </div>
        </div>
      </div>

      <footer class="exform-footer">
        <div class="footer-content">
          <span
            >By clicking to submit this form, you acknowledge that the
            information you provide will be transferred to DETAILS for
            processing in accordance with their
            <a href="#">Privacy Policy</a> and GDPR-compliant
            <a href="#">Terms</a>.</span
          >
        </div>

        <div class="powered-by ut-flex">
          <span>Powered by</span>
          <div class="logo-box">
            <img
              class="img-responsive company-logo"
              :src="`https://detailss3web.s3.amazonaws.com/images/logo/big_fat_demo_agencylogo`"
              alt
            />

            <!-- :src="
            `https://detailss3web.s3.amazonaws.com/images/logo/${
              this.clientName
            }logo`
          " -->
            <!-- <img alt="" class="img-responsive client-logo" src="https://detailss3web.s3.amazonaws.com/images/logo/big_fat_demo_agencylogo"> -->
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  clientName,
  JSON_STRING,
  MHTTPCL,
} from "../../../services/http/http-client";
import * as I18nActionTypes from "../../../store/app/i18n/types";
import NTable from "@/plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";
import BasicAccordion from "@plugins/basic-accordion/basic-accordion";

import ExternalFormHeader from "../external-form/header.vue";

import SwitchButton from "./switch-button";
import TravelBlock from "./travel-block";
import TravelTable from "./travel-table";

import { EventHooks } from "../../../plugins/text-field";
import { format } from "date-fns";
import { QuestionnaireService } from "../../../services/questionnaire.service";
import { Subject } from "rxjs";
import { allValidString, subscribeSubject, wait } from "../../../utility";
import { getContactDataFromMapResult } from "../../../models/maps.model";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";

import { TravelListMixin } from "../../../modules/booking/components/booking-sidewindow/travel-list-container.mixin";
import {
  filterTravelAfter,
  filterTravelBefore,
} from "../../../modules/booking/models/travel.model";
import * as querystring from "qs";
import { HttpLib } from "../../../services/http/http-lib";
import { async } from "ramda-adjunct";
import { flatten, toPairs } from "ramda";

import QuestionnaireArtwork from "./questionnaire-artwork.vue";
import {
  NotificationService,
  showError,
  showNotification,
} from "../../../dt-plugins/notification/notification.service";
import { createTV } from "../../../models/text-value.model";
import { sortLocalDetailsFields } from "../../../modules/booking/models/local-details.model";

export default {
  components: {
    ExternalFormHeader,
    NTable,
    InputField,

    BasicAccordion,
    SwitchButton,
    TravelBlock,
    TravelTable,
    QuestionnaireArtwork,
  },
  mixins: [TravelListMixin("travel_before", "travel_after")],
  data: function () {
    return {
      clientName: clientName,

      openedState: true,
      event_detailsExpandState: false,
      location_detailsExpandState: false,
      artist_detailsExpandState: {},
      contactExpandState: false,
      contract_partner_detailsExpandState: false,
      artworkExpandState: false,
      travel_beforeExpandState: false,
      travel_afterExpandState: false,
      localDetailsExpandState: {},

      changeState: "",

      showItem: true,
      switchValue: true,
      isFixed: false,
      submitButtonFlag: false,

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
      textAreaConfig: {
        height: 120,
        showEditIconOnHover: false,
        box: true,
        textarea: true,
        showValidationIcons: false,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },

      // typeAheadTextFieldConfig: {
      //   height: 42,
      //   showEditIconOnHover: false,
      //   box: true,
      //   showValidationIcons: false,
      //   validationEvent: EventHooks.OnKeyup,
      //   valueChangedEvent: EventHooks.OnKeyup,
      //   typeahead: true
      // },

      eventDetailsValidationResult: {},
      venueDetailsValidationResult: {},
      contactDetailsValidationResult: {},
      promoterDetailsValidationResult: {},
      localDetailsValidationResult: {},
      artistsValidationResult: {},

      questionnaire: null,

      validationIconVenue: "",
      language: "de",

      hotelTV: [],
      restaurantTV: [],
      hotelList: [],
      restaurantList: [],
      hotelSubject: new Subject(),
      restaurantSubject: new Subject(),
      selectedHotel: null,
    };
  },
  mounted: async function () {
    this.$store.dispatch(I18nActionTypes.UPDATE_SYSTEM_LANGUAGE, {
      locale: "en",
      language: "English",
    });

    const res = await QuestionnaireService.getData(
      this.checksum,
      this.promoter_id,
      this.calendar_date_id,
      this.language
    );

    this.questionnaire = {
      ...this.questionnaire,
      ...res.data,
    };
    // console.log("this.questionnaire = ", res.data);

    // console.log({ "questionnaire.rs.contact": this.questionnaire.rs.contact });
    // console.log({
    //   "questionnaire.rs.contact": this.questionnaire.contact_fields,
    // });

    subscribeSubject(
      this,
      this.hotelSubject,
      ([searchString, local_detail_id]) => {
        if (searchString.length > 0) {
          this.fetchHotel(searchString);
        }
        HttpLib.post(
          `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
          querystring.stringify({
            action: "modify_field",
            checksum: this.questionnaire?.checksum,
            promoter_id: this.questionnaire?.promoter_id,
            clientID: MHTTPCL.getClientName(),
            calendar_date_id: this.questionnaire?.calendar_date_id,
            // modify_type: "record",
            kVal: local_detail_id,
            name: "name",
            value: searchString,
            table: "local_details",
          })
        ).then((res) => {
          // console.log("res = ", res);
        });
      },
      // 1000
    );
    subscribeSubject(
      this,
      this.restaurantSubject,
      ([searchString, local_detail_id]) => {
        if (searchString.length > 0) {
          this.fetchRestaurant(searchString);
        }
        HttpLib.post(
          `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
          querystring.stringify({
            action: "modify_field",
            checksum: this.questionnaire?.checksum,
            promoter_id: this.questionnaire?.promoter_id,
            clientID: MHTTPCL.getClientName(),
            calendar_date_id: this.questionnaire?.calendar_date_id,
            // modify_type: "record",
            kVal: local_detail_id,
            name: "name",
            value: searchString,
            table: "local_details",
          })
        ).then((res) => {
          // console.log("res = ", res);
        });
      }
    );

    // console.log(
    //   "artist name ",
    //   this.questionnaire?.artists.map((e) => e.artist_name)
    // );

    // Sticky header
    // window.document.onscroll = () => {
    //   let navBar = document.getElementById("sticky");
    //   if (window.scrollY > navBar.offsetTop) {
    //     this.isFixed = true;
    //   } else {
    //     this.isFixed = false;
    //   }
    // };
    // window.addEventListener("scroll", function() {
    //   let topBar = document.querySelector(".top-bar");

    //   topBar.classList.toggle("sticky", window.scrollY > 0);
    // });

    window.addEventListener("scroll", function () {
      let header = document.querySelector(".header");
      header.classList.toggle("sticky", window.scrollY > 0);
    });
  },
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 3,
        rowHeight: 28,
        fullHeight: true,
      });
    },
    travelListHeaders: function () {
      return [
        createTableHeader("passanger"),
        createTableHeader("from"),
        createTableHeader("to", { ta: "center" }),
        createTableHeader("carrier", { mw: 75 }),
        createTableHeader("rs_travel", { mw: 75 }),
        createTableHeader("tab_title_costs", { mw: 75 }),
        createTableHeader("confirmed", {
          ta: "right",
        }),
      ];
    },
    calendar_date_id: function () {
      return this.$route.query.calendar_date_id || null;
    },
    promoter_id: function () {
      return this.$route.query.promoter_id || null;
    },
    checksum: function () {
      return this.$route.query.checksum || null;
    },
    recipient_user_id: function () {
      return this.$route.query.recipient_user_id || null;
    },

    travelBeforeData: function () {
      return filterTravelBefore(
        this.questionnaire?.travels,
        this.questionnaire?.cdate
      );
    },
    travelAfterData: function () {
      return filterTravelAfter(
        this.questionnaire?.travels,
        this.questionnaire?.cdate
      );
    },

    artistNames: function () {
      return this.questionnaire?.artists.map((e) => e.artist_name).join(", ");
    },

    localDetailsList() {
      // console.log(
      //   "ld",
      //   this.questionnaire?.booking_local_details_data.map((ldData) => {
      //     const keys = sortLocalDetailsFields(
      //       ldData?.local_details_elements?.split(",")
      //     );
      //     const ldList = [
      //       ...(keys?.map((e) => {
      //         return {
      //           name: e,
      //           value: ldData?.[e],
      //         };
      //       }) || []),
      //       ...this.questionnaire?.[`local_details_${ldData.local_detail_id}`],
      //     ];
      //     console.log(ldList);
      //     return {
      //       local_detail_id: ldData.local_detail_id,
      //       name: ldData.local_details_type_name,
      //       localDetailsForm: ldList,
      //     };
      //   })
      // );
      return (
        this.questionnaire?.booking_local_details_data?.map((ldData) => {
          const keys = sortLocalDetailsFields(
            ldData?.local_details_elements?.split(",")
          );
          const ldList = [
            ...(keys?.map((e) => {
              return {
                name: e,
                value: ldData?.[e],
              };
            }) || []),
            ...this.questionnaire?.[`local_details_${ldData.local_detail_id}`],
          ];
          // console.log(
          //   "ldList",
          //   ldList,
          //   ldData,
          //   this.questionnaire[`local_details_${ldData.local_detail_id}`]
          // );
          return {
            local_detail_id: ldData.local_detail_id,
            name: ldData.local_details_type_name,
            localDetailsForm: ldList,
          };
        }) || []
      );
      // return Object.keys(this.questionnaire)
      //   .filter(e => {
      //     if (/local_details_\d/i.test(e)) {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   })
      //   .reduce((accm, cur) => {
      //     const ld = this.questionnaire[cur];
      //     accm = [...accm, ld];
      //     return accm;
      //   }, []);
    },

    hotelValues: function () {
      return this.localDetailsList
        .filter((e) => e.name == "Hotel")
        .map((h) => {
          return `${h.localDetailsForm
            .map((field) => {
              if (field.name) {
                return field.value;
              }
            })
            .filter((e) => e)
            .join("\n")}
          ${h.localDetailsForm
            .map((field) => {
              if (field.field_label) {
                return `${field.field_label} : ${field.data}\n`;
              }
            })
            .filter((e) => e)
            .join("\n")}
          `;
        });
    },

    languagesTV: function () {
      return this.$store.getters.systemLanguagesTV;
    },

    isFormValidEventDetails: function () {
      return Object.values(this.eventDetailsValidationResult).every(
        (e) => e.valid
      );
    },
    isFormValidVenueDetails: function () {
      return Object.values(this.venueDetailsValidationResult).every(
        (e) => e.valid
      );
    },
    isFormValidContactDetails: function () {
      return Object.values(this.contactDetailsValidationResult).every(
        (e) => e.valid
      );
    },
    isFormValidPromoterDetails: function () {
      return Object.values(this.promoterDetailsValidationResult).every(
        (e) => e.valid
      );
    },
    isFormValidLocalDetails: function () {
      return flatten(
        Object.values(this.localDetailsValidationResult).map((e) =>
          Object.values(e)
        )
      ).every((e) => e.valid);
    },
    isFormValidArtistDetails: function () {
      return flatten(
        Object.values(this.artistsValidationResult).map((e) => Object.values(e))
      ).every((e) => e.valid);
    },

    isValidComplete: function () {
      return (
        this.isFormValidEventDetails &&
        this.isFormValidVenueDetails &&
        this.isFormValidContactDetails &&
        this.isFormValidPromoterDetails &&
        this.isFormValidLocalDetails &&
        this.isFormValidArtistDetails
      );
    },
    lockJson() {
      return this.questionnaire?.cdate?.lock_json
        ? JSON.parse(this.questionnaire.cdate.lock_json)
        : {};
    },
    isEventDetailsLocked() {
      let lockedArtists = this.questionnaire.artists.filter(
        (artist) =>
          this.lockJson[
            `calendar_date_artists_${artist.calendar_date_artist_id}`
          ] === "lock"
      );
      return (
        this.questionnaire.artists.length === lockedArtists.length ||
        this.lockJson.calendar_dates_event === "lock"
      );
    },
  },
  methods: {
    getLocalDetailsName(ld) {
      // console.log(ld);
      return (
        this.questionnaire?.booking_local_details_data?.find((e) => {
          if (e.local_detail_id == ld.external_id) {
            return true;
          } else {
            return false;
          }
        })?.local_details_type_name || "Name"
      );
    },

    onShowAccordion: function (accordionKey, value) {
      // console.log("Accordion key ", accordionKey, value);

      switch (accordionKey) {
        case "event_details":
          if (this.openedState == true) {
            this.event_detailsExpandState = false;
            this.openedState = false;
          } else {
            this.event_detailsExpandState = !value;
          }
          break;
        case "location_details":
          this.location_detailsExpandState = !value;
          break;
        case "contact":
          this.contactExpandState = !value;
          break;
        case "contract_partner_details":
          this.contract_partner_detailsExpandState = !value;
          break;
        case "artwork":
          this.artworkExpandState = !value;
          break;
        case "travel_before":
          this.travel_beforeExpandState = !value;
          break;
        case "travel_after":
          this.travel_afterExpandState = !value;
          break;
        default:
          break;
      }
    },

    onShowAccordionArtist: function (accordionKey, value) {
      // console.log("Accordion key ", accordionKey, value);
      this.artist_detailsExpandState = {
        ...this.artist_detailsExpandState,
        [accordionKey]: !value,
      };
    },

    onShowAccordionLocalDetails: function (accordionKey, value) {
      // console.log("Accordion key ", accordionKey, value);

      this.localDetailsExpandState = {
        ...this.localDetailsExpandState,
        [accordionKey]: !value,
      };
    },

    onChangeSwitchValue: function () {
      this.switchValue = !this.switchValue;
    },

    onTextFieldEventValueChange: async function (name, value) {
      this.questionnaire = {
        ...this.questionnaire,
        cdate: {
          ...this.questionnaire?.cdate,
          [name]: value,
        },
      };
      // console.log("onTextField Event Value update ", this.questionnaire?.cdate);

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: this.questionnaire?.calendar_date_id,
          name,
          value,
          table: "calendar_dates",
        })
      );
    },

    onContactFieldsUpdate: async function (name, value, field) {
      // console.log("onContactFields Update ", name, value, field);
      this.questionnaire = {
        ...this.questionnaire,
        contact_fields: this.questionnaire?.contact_fields.map((e) => {
          if (e.custom_data_id == field.custom_data_id) {
            return {
              ...e,
              data: value,
            };
          } else {
            return e;
          }
        }),
      };

      // console.log(
      //   "this.questionnaire?.contact_fields update_2",
      //   this.questionnaire?.contact_fields
      // );

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: field.custom_data_id,
          name: "data",
          value,
          table: "custom_data",
        })
      );
    },

    onVenueFieldsUpdate: async function (name, value, field) {
      // console.log("onVenueFields Update ", name, value, field);
      this.questionnaire = {
        ...this.questionnaire,
        venue_fields: this.questionnaire?.venue_fields.map((e) => {
          if (e.custom_data_id == field.custom_data_id) {
            return {
              ...e,
              data: value,
            };
          } else {
            return e;
          }
        }),
      };

      // console.log(
      //   "this.questionnaire?.venue_fields update_2",
      //   this.questionnaire?.venue_fields
      // );

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: field.custom_data_id,
          name: "data",
          value,
          table: "custom_data",
        })
      );
    },

    onEventFieldsUpdate: async function (name, value, field) {
      // console.log("onEventFields Update ", name, value, field);
      this.questionnaire = {
        ...this.questionnaire,
        event_fields: this.questionnaire?.event_fields.map((e) => {
          if (e.custom_data_id == field.custom_data_id) {
            return {
              ...e,
              data: value,
            };
          } else {
            return e;
          }
        }),
      };

      // console.log(
      //   "this.questionnaire?.event_fields update_2",
      //   this.questionnaire?.event_fields
      // );

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: field.custom_data_id,
          name: "data",
          value,
          table: "custom_data",
        })
      );
    },

    onPromoterFieldsUpdate: async function (name, value, field) {
      // console.log("onPromoterFields Update ", name, value, field);
      this.questionnaire = {
        ...this.questionnaire,
        promoter_fields: this.questionnaire?.promoter_fields.map((e) => {
          if (e.custom_data_id == field.custom_data_id) {
            return {
              ...e,
              data: value,
            };
          } else {
            return e;
          }
        }),
      };

      // console.log(
      //   "this.questionnaire?.promoter_fields update_2",
      //   this.questionnaire?.promoter_fields
      // );

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: field.custom_data_id,
          name: "data",
          value,
          table: "custom_data",
        })
      );
    },

    onVenueTextFieldValueChange: async function (name, value) {
      this.questionnaire = {
        ...this.questionnaire,
        venue: {
          ...this.questionnaire?.venue,
          [name]: value,
        },
      };

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: this.questionnaire?.venue?.booking_location_id,
          name,
          value,
          table: "booking_locations",
        })
      );
    },

    onArtistTextFieldValueChange: async function (name, value, index) {
      // Done update
      // console.log("onArtist TextFieldValueChange ", name, value, index);
      this.questionnaire = {
        ...this.questionnaire,
        artists: this.questionnaire?.artists.map((artist, i) => {
          if (i == index) {
            return {
              ...artist,
              [name]: value,
            };
          } else {
            return artist;
          }
        }),
      };
      // console.log("onTextField Artists Value update ", this.questionnaire?.artists);

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: this.questionnaire?.artists[index].calendar_date_artist_id,
          name,
          value,
          table: "calendar_date_artists",
        })
      );
    },

    onContactTextFieldValueChange: async function (name, value) {
      this.questionnaire = {
        ...this.questionnaire,
        contact: {
          ...this.questionnaire?.contact,
          [name]: value,
        },
      };

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: this.questionnaire?.contact?.contact_id,
          name,
          value,
          table: "contacts",
        })
      );
    },

    onPromoterTextFieldValueChange: async function (name, value) {
      this.questionnaire = {
        ...this.questionnaire,
        promoter: {
          ...this.questionnaire?.promoter,
          [name]: value,
        },
      };

      // console.log("Promoter update ", this.questionnaire?.promoter);

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: this.questionnaire?.promoter_id,
          name,
          value,
          table: "contacts",
        })
      );
    },

    // Local Details Methods
    fetchHotel: async function (term) {
      const res = await QuestionnaireService.findHotelList(
        this.checksum,
        this.promoter_id,
        this.calendar_date_id,
        this.language,
        term
      );

      // console.log("fetchHotel res ", res.data.content.results);
      this.hotelList = res.data.content.results;

      this.hotelTV = createTV(
        res.data.content.results || [],
        "name",
        "place_id"
      );
      // console.log("hotelTV ", this.hotelTV);
    },
    fetchRestaurant: async function (term) {
      const searchTypeParam = "restaurant";

      const res = await QuestionnaireService.findHotelList(
        this.checksum,
        this.promoter_id,
        this.calendar_date_id,
        this.language,
        term,
        searchTypeParam
      );

      // console.log("fetchHotel res ", res.data.content.results);
      this.restaurantList = res.data.content.results;

      this.restaurantTV = createTV(
        res.data.content.results || [],
        "name",
        "place_id"
      );
      // console.log("hotelTV ", this.hotelTV);
    },

    onLocalDetailsOptionSelected: async function (selected, localDetails) {
      let selectedHotel, selectedRestaurant;

      if (localDetails.name == "Hotel" && name == "name") {
        selectedHotel = this.hotelList.find(
          (e) => e.place_id == selected.value
        );
      } else if (localDetails.name == "Restaurant" && name == "name") {
        selectedRestaurant = this.restaurantList.find(
          (e) => e.place_id == selected.value
        );
      }

      const res = await QuestionnaireService.getHotelDetails(
        this.checksum,
        this.promoter_id,
        this.calendar_date_id,
        this.language,
        selected.value
      );
      // console.log("Hotel selected ", res.data.content.result);

      // console.log(
      //   "address_components ",
      //   res.data.content.result.address_components
      // );

      // const newplace = {
      //   city: res.data.content.result.address_components.find(e => 'postalcode/ others'),
      // };

      await wait(500);

      const googlePlaceData = getContactDataFromMapResult(
        res.data?.content?.result
      );

      // console.log("googlePlaceData ", googlePlaceData);

      // toPairs(googlePlaceData).forEach(async ([name, value]) => {
      //   await this.updateQuestionnaire(localDetails.local_detail_id, encodeURIComponent(name), value, 'local_details');
      // });

      if (googlePlaceData) {
        this.questionnaire = {
          ...this.questionnaire,
          booking_local_details_data:
            this.questionnaire?.booking_local_details_data.map((e) => {
              if (e.local_detail_id == localDetails.local_detail_id) {
                return {
                  ...e,
                  ...googlePlaceData,
                };
              } else {
                return e;
              }
            }),
        };

        // for (const [name, value] of toPairs(googlePlaceData)) {
        //   await this.updateQuestionnaire(
        //     localDetails.local_detail_id,
        //     encodeURIComponent(name),
        //     value,
        //     "local_details"
        //   );
        // }

        let updateRecord = { modify_type: "record" };
        for (const [name, value] of toPairs(googlePlaceData)) {
          updateRecord = {...updateRecord, [encodeURIComponent(name)]: value};
        }
        
        await this.updateQuestionnaire(
          localDetails.local_detail_id,
          '',
          '',
          "local_details",
          updateRecord
        );
        
      }
    },

    getLDConditionalConfig(localDetails, name) {
      // console.log("Local tv ", localDetails, name);
      if (
        (localDetails.name == "Hotel" || localDetails.name == "Restaurant") &&
        name == "name"
      ) {
        // console.log("Hotel & Restaurant show");
        return {
          height: 42,
          showEditIconOnHover: false,
          box: true,
          showValidationIcons: false,
          validationEvent: EventHooks.OnKeyup,
          valueChangedEvent: EventHooks.OnKeyup,
          typeahead: true,
        };
      } else {
        // console.log("normal field");
        return {
          height: 42,
          showEditIconOnHover: false,
          box: true,
          showValidationIcons: false,
          validationEvent: EventHooks.OnBlur,
          valueChangedEvent: EventHooks.OnBlur,
        };
      }
    },

    onLocalDetailsUpdate: async function (name, value, field, localDetails) {
      this.questionnaire = {
        ...this.questionnaire,
        booking_local_details_data:
          this.questionnaire?.booking_local_details_data.map((e) => {
            if (e.local_detail_id == localDetails.local_detail_id) {
              return {
                ...e,
                [name]: value,
              };
            } else {
              return e;
            }
          }),
      };

      // console.log(
      //   "onLocalDetailsUpdate ",
      //   this.questionnaire?.booking_local_details_data
      // );

      // console.log(
      //   "onLocalDetails Update--- ",
      //   name,
      //   // value,
      //   field,
      //   localDetails.name
      // );

      // console.log({ name, "[value, localDetails.local_detail_id]": [ value, localDetails.local_detail_id, ], "localDetails.name": localDetails.name, });

      if (localDetails.name == "Hotel" && name == "name") {
        // console.log("Hotel name ", value, localDetails.local_detail_id);
        this.hotelSubject.next([value, localDetails.local_detail_id]);
      } else if (localDetails.name == "Restaurant" && name == "name") {
        // console.log("Restaurant ", value, localDetails.local_detail_id);
        this.restaurantSubject.next([value, localDetails.local_detail_id]);
      } else {
        await HttpLib.post(
          `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
          querystring.stringify({
            action: "modify_field",
            checksum: this.questionnaire?.checksum,
            promoter_id: this.questionnaire?.promoter_id,
            clientID: MHTTPCL.getClientName(),
            calendar_date_id: this.questionnaire?.calendar_date_id,
            // modify_type: "record",
            kVal: localDetails.local_detail_id,
            name,
            value,
            table: "local_details",
          })
        );
      }
    },

    onLocalDetailsCustomUpdate: async function (value, ld) {
      // console.log("onLocalDetailsCustomUpdate ", name, value, ld);
      this.questionnaire = {
        ...this.questionnaire,
        [`local_details_${ld.external_id}`]: this.questionnaire?.[
          `local_details_${ld.external_id}`
        ].map((e) => {
          if (e.custom_data_id == ld.custom_data_id) {
            return {
              ...e,
              data: value,
            };
          } else {
            return e;
          }
        }),
      };

      // console.log(
      //   "onLocalDetails Custom Update ",
      //   this.questionnaire?.[`local_details_${ld.external_id}`]
      // );

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: ld.custom_data_id,
          name: "data",
          value,
          table: "custom_data",
        })
      );
    },

    async updateQuestionnaire(kVal, name, value, table, params={}) {
      const argumentsValidity = allValidString(kVal, name, value, table);
      if (argumentsValidity.valid) {
        const mergedParams = {kVal, name, value, table, ...params};
        await HttpLib.post(
          `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
          querystring.stringify({
            action: "modify_field",
            checksum: this.questionnaire?.checksum,
            promoter_id: this.questionnaire?.promoter_id,
            clientID: MHTTPCL.getClientName(),
            calendar_date_id: this.questionnaire?.calendar_date_id,
            ...mergedParams,

            // kVal,
            // name,
            // value,
            // table,
          })
        );
      } else {
        // console.log("Invalid arguments", argumentsValidity.invalid);
      }
    },

    onArtistsFieldsUpdate: async function (name, value, artist) {
      // console.log("onArtistsFields Update ", name, value, artist);

      this.questionnaire = {
        ...this.questionnaire,
        calendar_date_artists_fields: {
          ...this.questionnaire?.calendar_date_artists_fields,
          [artist.external_id]:
            this.questionnaire?.calendar_date_artists_fields[
              artist.external_id
            ].map((e) => {
              if (e.custom_data_id == artist.custom_data_id) {
                return {
                  ...e,
                  data: value,
                };
              } else {
                return e;
              }
            }),
        },
      };

      await HttpLib.post(
        `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${this.questionnaire?.checksum}/${this.questionnaire?.promoter_id}/calendar_date_id=${this.questionnaire?.calendar_date_id}&lang=${this.questionnaire?.lang}&viewtype=original`,
        querystring.stringify({
          action: "modify_field",
          checksum: this.questionnaire?.checksum,
          promoter_id: this.questionnaire?.promoter_id,
          clientID: MHTTPCL.getClientName(),
          calendar_date_id: this.questionnaire?.calendar_date_id,
          // modify_type: "record",
          kVal: artist.custom_data_id,
          name: "data",
          value,
          table: "custom_data",
        })
      );
    },

    onLanguageChange: function (e) {
      this.language = e.value;
      this.$store.dispatch(I18nActionTypes.UPDATE_SYSTEM_LANGUAGE, e);
    },

    onEventDetailsValidation: function (name, value) {
      this.$set(this.eventDetailsValidationResult, name, value);
    },
    onEventFieldValidation: function (name, value, eventField) {
      // console.log("Event ", name, value, eventField);
      this.eventDetailsValidationResult = {
        ...this.eventDetailsValidationResult,
        [name]: value,
      };
    },

    onVenueDetailsValidation: function (name, value) {
      this.$set(this.venueDetailsValidationResult, name, value);
      const valid = Object.values(this.venueDetailsValidationResult).every(
        (e) => e.valid
      );
      if (valid) {
        this.validationIconVenue = "textbox-complete.svg";
      } else {
        this.validationIconVenue = "textbox-incomplete.svg";
      }
    },

    onVenueFieldValidation: function (name, value, eventField) {
      // console.log("Venue ", name, value, eventField);
      this.$set(this.venueDetailsValidationResult, name, value);

      this.venueDetailsValidationResult = {
        ...this.venueDetailsValidationResult,
        [name]: value,
      };
      const valid = Object.values(this.venueDetailsValidationResult).every(
        (e) => e.valid
      );
      if (valid) {
        this.validationIconVenue = "textbox-complete.svg";
      } else {
        this.validationIconVenue = "textbox-incomplete.svg";
      }
    },

    onContactDetailsValidation: function (name, value) {
      this.$set(this.contactDetailsValidationResult, name, value);
    },

    onContactFieldValidation: function (name, value, contactField) {
      // console.log("Contact ", name, value, contactField);
      this.$set(this.contactDetailsValidationResult, name, value);

      this.contactDetailsValidationResult = {
        ...this.contactDetailsValidationResult,
        [name]: value,
      };
    },

    onPromoterDetailsValidation: function (name, value) {
      this.$set(this.promoterDetailsValidationResult, name, value);
    },
    onPromoterFieldValidation: function (name, value, promoterField) {
      // console.log("Promoter ", name, value, promoterField);
      // this.$set(this.contactDetailsValidationResult, name, value);
      this.$set(this.promoterDetailsValidationResult, name, value);

      this.promoterDetailsValidationResult = {
        ...this.promoterDetailsValidationResult,
        [name]: value,
      };
    },

    onLocalDetailsValidation: function (name, value, field, localDetails) {
      this.localDetailsValidationResult = {
        ...this.localDetailsValidationResult,
        [localDetails.local_detail_id]: {
          ...this.localDetailsValidationResult[localDetails.local_detail_id],
          [name]: value,
        },
      };
    },

    onArtistDetailsValidation: function (name, value, index, artist) {
      // console.log("artist ", name, value, index, artist);

      this.artistsValidationResult = {
        ...this.artistsValidationResult,
        [artist.artist_id]: {
          ...this.artistsValidationResult[artist.artist_id],
          [name]: value,
        },
      };
    },

    onArtistsFieldValidation: function (name, value, artist) {
      // console.log("artist ", name, value, artist);

      this.artistsValidationResult = {
        ...this.artistsValidationResult,
        [artist.artist_id]: {
          ...this.artistsValidationResult[artist.artist_id],
          [name]: value,
        },
      };
    },

    artistFields() {
      return Object.values(this.questionnaire?.calendar_date_artists_fields);
    },

    get_questionnaire: function () {
      return {
        ques_lineup: "",
        booking_location_name: "",
        cdate: {},
        calendar_date_artists_fields: {},
        venue: {},
        contact: {},
        promoter: {},
        artists: [],
        travels: [],
        event_fields: [],
        venue_fields: [],
        promoter_fields: [],
        contact_fields: [],
      };
    },

    ldStringValue(ldName) {
      return this.localDetailsList
        .filter((e) => e.name.toLowerCase() == ldName.toLowerCase())
        .map((h) => {
          return `${h.localDetailsForm
            .map((field) => {
              if (field.name) {
                return field.value;
              }
            })
            .filter((e) => e)
            .join("\n")}
          ${h.localDetailsForm
            .map((field) => {
              if (field.field_label) {
                return `${field.field_label} : ${field.data}\n`;
              }
            })
            .filter((e) => e)
            .join("\n")}
          `;
        })
        .join("\n");
    },

    onSubmit: async function () {
      const start_date = this.questionnaire?.cdate?.start_date || "";
      const city = this.questionnaire?.venue?.city || "";
      const company_name = this.questionnaire?.promoter?.company_name || "";
      const booking_location_name =
        this.questionnaire?.venue?.booking_location_name || undefined;
      const email1 = this.questionnaire?.promoter?.email1 || "";
      const email2 = this.questionnaire?.promoter?.email2 || "";
      const phone1 = this.questionnaire?.promoter?.phone1 || "";
      const mobile1 = this.questionnaire?.promoter?.mobile1 || "";
      const mobile2 = this.questionnaire?.promoter?.mobile2 || "";
      const venue_address1 = this.questionnaire?.venue?.address1 || "";
      const venue_address2 = this.questionnaire?.venue?.address2 || "";
      const venue_postalcode = this.questionnaire?.venue?.postalcode || "";
      const venue_country = this.questionnaire?.venue?.country || "";

      const comment = `Subject: Promoter Questionnaire sent for ${start_date} in ${city} / ${booking_location_name} / ${company_name} - ${this.artistNames}`;
      const text = `Subject: Promoter Questionnaire sent for ${start_date} in ${city} / ${booking_location_name} / ${company_name}
        promoter: ${company_name} ${email1} ${email2} ${phone1} ${phone1} ${mobile1} ${mobile2} location: ${booking_location_name} ${venue_address1} ${venue_address2} ${city} ${venue_postalcode} ${venue_country} hotel:  ${this.ldStringValue(
        "Hotel"
      )} night manager: ${this.ldStringValue(
        "night manager"
      )} driver1: ${this.ldStringValue(
        "driver1"
      )} driver2: ${this.ldStringValue(
        "driver2"
      )} technician: ${this.ldStringValue(
        "technician"
      )} restaurant: ${this.ldStringValue("restaurant")}`;

      // console.log("text", text);

      if (!this.isValidComplete) {
        // console.log(
        //   "ksjdfkjds fjdsjf fdlasjd ",
        //   this.artist_detailsExpandState
        // );

        showError("Please fill up all required information");

        // NotificationService.showNotification({
        //   text: `Please fill up all required information`,
        //   timeout: 1500,
        //   type: "error",
        // }).then(() => {
        //   NotificationService.showNotification({
        //     text: `All Panels are opened`,
        //     timeout: 3000,
        //     type: "normal",
        //   });
        // });

        if (
          !(
            this.event_detailsExpandState &&
            this.location_detailsExpandState &&
            this.contactExpandState &&
            this.contract_partner_detailsExpandState &&
            this.artworkExpandState &&
            this.travel_beforeExpandState &&
            this.travel_afterExpandState
          )
        ) {
          await wait(1000);
          showNotification("All Panels are opened");
          this.event_detailsExpandState = true;
          this.location_detailsExpandState = true;
          this.contactExpandState = true;
          this.contract_partner_detailsExpandState = true;
          this.artworkExpandState = true;
          this.travel_beforeExpandState = true;
          this.travel_afterExpandState = true;
          this.artist_detailsExpandState = this.questionnaire?.artists.reduce(
            (accm, cur) => {
              accm = {
                ...accm,
                [cur.artist_id]: true,
              };
              return accm;
            },
            {}
          );

          this.localDetailsExpandState =
            this.questionnaire?.booking_local_details_data?.reduce(
              (accm, cur) => {
                accm = {
                  ...accm,
                  [cur.local_detail_id]: true,
                };
                return accm;
              },
              {}
            );
        }
      } else {
        // console.log("Successfull..... ");

        // await HttpLib.get(
        //   `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${
        //     this.questionnaire?.checksum
        //   }/${this.questionnaire?.promoter_id}/calendar_date_id=${
        //     this.questionnaire?.calendar_date_id
        //   }&lang=${
        //     this.questionnaire?.lang
        //   }&viewtype=original?action:create_memo&recipient_user_id=${
        //     this.recipient_user_id
        //   }&date_due=${this.questionnaire?.cdate.start_date}&calendar_date_id=${
        //     this.questionnaire?.calendar_date_id
        //   }&text=${text}&comment=${comment}`
        await HttpLib.get(
          `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName}/${
            this.questionnaire?.checksum
          }/${this.questionnaire?.promoter_id}/calendar_date_id=${
            this.questionnaire?.calendar_date_id
          }&lang=${
            this.questionnaire?.lang
          }&viewtype=original?action=create_memo&recipient_user_id=${
            this.recipient_user_id
          }&date_due=${this.questionnaire?.cdate.start_date}&calendar_date_id=${
            this.questionnaire?.calendar_date_id
          }&${querystring.stringify({
            text,
            comment,
          })}`
        );

        showNotification("Successfully sent Questionnaire");
        this.submitButtonFlag = true;
      }
    },
    is1(value) {
      return value == 1 || value == "1";
    },
    calendar_dateRequired(key) {
      return this.lockJson['calendar_dates_event'] != "lock" &&
      (this.is1(this.questionnaire?.rs?.calendar_date?.[key]?.mandatory) ? true : false)
        ? true
        : false;
    },
    booking_locationRequired(key) {      
      return this.lockJson['calendar_dates_venue'] != "lock" &&
      (this.is1(this.questionnaire?.rs?.booking_location?.[key]?.mandatory) ? true : false)
        ? true
        : false;
    },
    calendarDateArtistRequired(artist, key) {
      return this.lockJson[
        `calendar_date_artists_${artist.calendar_date_artist_id}`
      ] != "lock" &&
        (this.is1(this.questionnaire?.rs?.calendar_date_artist?.[key].mandatory)
          ? true
          : false)
        ? true
        : false;
    },
    promoterRequired(key) {
      return this.lockJson['calendar_dates_promoter'] != "lock" &&
      (this.is1(this.questionnaire?.rs?.promoter?.[key].mandatory) ? true : false)
        ? true
        : false;
    },
    contactRequired(key) {
      return this.lockJson['calendar_dates_contact'] != "lock" &&
      (this.is1(this.questionnaire?.rs?.contact?.[key].mandatory) ? true : false)
        ? true
        : false;
    },
  },
};
</script>

<style lang="scss">
.cmp-questionnaire,
.external-form {
  --bc-accent5: #0087ff;
  --default-questionnaire-bc: var(--bc-3);
  --default-questionnaire-card-border: var(--sprt-85);
  --default-questionnaire-indicator-color: var(--text-primary);

  height: 100%;
  background-color: var(--default-questionnaire-bc);
  &.dark {
    --default-questionnaire-bc: var(--bc-darker);
    --default-questionnaire-card-border: var(--sprt-5);
    --default-questionnaire-indicator-color: var(--text-lightest);
    background-color: var(--bc-darker);
    .cmp-plugins-basic_accordion {
      box-shadow: none;
      outline: none;
    }
    .basic-accordion {
      border-color: transparent;
      box-shadow: none;
      .accordion-header {
        .arrow {
          border-color: var(--text-lightest);
        }
      }
      .accordion-header,
      .accordion-body {
        background-color: var(--bc-dark-container);
        color: var(--text-lightest);
        input,
        textarea,
        .dropdown--main__text {
          color: var(--text-lightest);
        }
        .dt-input-box--label.input,
        .dt-input-box--label.textarea,
        .dropdown--main__label {
          color: var(--text-5);
        }
        .dt-input-box.disabled:not(.readonly) {
          background-color: transparent;
        }
      }
    }
    .expand {
      box-shadow: 0 4px 10px transparent;
      .basic-accordion {
        border-color: transparent;
      }
    }

    .page-header-inner {
      background-color: var(--bc-darker);
    }

    .lock-wrap {
      span {
        // color: var(--text-lightest);
      }
      img {
        // display: none;
        &.dark-mode {
          // display: block;
        }
      }
    }
  }

  .lock-wrap {
    img {
      &.dark-mode {
        // display: none;
      }
    }
  }

  .travel-contaiter {
    background-color: var(--default-questionnaire-bc);
    border: 1px solid var(--default-questionnaire-card-border);
    padding: 7px 10px;
    margin-bottom: 10px;
    border-radius: 3px;
  }

  .travel-block {
    /* &>.ut-fc {
      &>.ut-flex {
        justify-content: space-between;
        div:nth-child(1) {
          flex: 4;
        }
        div:nth-child(2) {
          flex: 1;
          min-width: 80px;
        }
        div:nth-child(3) {
          flex: 1;
          min-width: 80px;
        }
      }
    } */

    .keyvalue-container {
      flex: 1;
      justify-content: space-between;
      min-height: 40px;
      padding-left: 10px;

      .keyvalue-item {
        display: flex;
        align-items: center;
        font-size: 13px;
        line-height: 16px;
        color: #828282;
        .key {
          font-weight: bold;
          min-width: 88px;
        }
        .value {
          display: flex;
          span {
            margin-left: 10px;
          }
        }
        @media (max-width: 767px) {
          flex-direction: column;
          align-items: flex-start;
          .value {
            flex-direction: column;
            margin-bottom: 10px;
            span {
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    transition: all 0.6s linear;
    &.sticky {
      .top-bar {
        height: 52px;
        transition: all 0.6s linear;
        .logo-box {
          height: 100%;
          .company-logo {
            // max-width: 32px;
            max-height: 32px;
          }
        }
      }
    }
  }

  .footer-questionnaire,
  .exform-footer {
    margin: 80px 0;
    .footer-content {
      max-width: 665px;
    }
    .footer-content,
    .powered-by {
      span {
        display: block;
        line-height: 18px;
        color: #828282;
      }

      a {
        color: #0087ff;
      }
    }
    .powered-by {
      margin-top: 32px;
      .logo-box {
        margin-left: 8px;
        .company-logo {
          display: block;
          width: 100%;
          max-width: 82px;
        }
      }
    }
  }
  .top-bar {
    width: 100%;
    height: 120px;
    padding: 10px 0;
    background-color: var(--bc-darker);
    transition: all 0.6s linear;
    // &.sticky {
    //   // position: fixed;
    //   // top: 0;
    //   // left: 0;
    //   // z-index: 1;
    //   // width: 100%;
    //   height: 52px;
    //   align-items: center;
    //   transition: all 0.6s linear;
    //   .logo-box {
    //     height: 100%;
    //     .company-logo {
    //       // max-width: 32px;
    //     }
    //   }
    // }
    .top-bar-inner {
      display: flex;
      width: 100%;
      height: 100%;
      padding: 0 40px;
      @media (min-width: 1200px) {
        max-width: 1400px;
        margin-right: auto;
        margin-left: auto;
      }
    }

    .logo {
      flex: 3;
      transition: all 0.6s linear;

      .company-logo {
        display: block;
        // width: 100%;
        max-height: 100px;
        transition: all 0.6s linear;
      }
    }

    .logo-box {
      // max-width: 100px;
      height: 100%;
    }

    .language-box {
      flex: 1;
      max-width: 100px;
      min-width: 100px;
      padding-top: 5px;
      transition: all 0.6s linear;

      .dropdown {
        border: 1px solid var(--text-lightest);
        z-index: 99;
        border-radius: 3px;
      }

      .dropdown--main__text {
        color: var(--text-lightest);
      }
      .dropdown--main {
        padding: 0 0 0 5px;
        .dropdown--main__icon {
          padding-right: 0;
          position: relative;
          &:before {
            content: "";
            position: absolute;
            top: 0;
            right: 14px;
            width: 1px;
            height: 20px;
            background-color: var(--text-lightest);
          }
          &:after {
            content: "";
            border: solid var(--text-lightest);
            border-width: 0 1px 1px 0;
            display: inline-block;
            padding: 2px;
            position: absolute;
            top: 6px;
            right: 4px;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
          }
        }
        img.dt-icon.s1 {
          display: none;
        }
      }
    }
  }

  .page-header-inner {
    padding: 0 40px;
    margin-bottom: 20px;
    background-color: var(--default-questionnaire-bc);
    transition: all 0.6s linear;
    @media (min-width: 1200px) {
      width: 100%;
      max-width: 1400px;
      margin-right: auto;
      margin-left: auto;
    }
  }

  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    padding: 10px 0;
    border-bottom: 1px solid var(--text-accent);

    .buton-group {
      display: flex;
      transition: all 0.6s linear;
      .dt-button {
        width: 138px;
        height: 30px;
        border-color: var(--bc-accent5);
        color: #fff;
        background: var(--bc-accent5);
        margin-right: 0;
      }
    }

    // @media screen and (max-width: 767px) {
    //   height: auto !important;
    // }
  }

  .page-titile {
    flex-grow: 1;
    font-size: 16px;
    color: var(--text-accent);

    // small screen media query
    @media screen and (max-width: 767px) {
      white-space: nowrap;
      max-width: calc(100% - 150px);
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  // .top-bar.sticky + .container {
  //   padding-top: 150px;
  // }

  .header.sticky + .container {
    // padding-top: 150px;
    transition: all 0.6s linear;
  }

  .container {
    height: 100%;
    padding: 190px 40px 0;
    transition: all 0.69s linear;

    .questionnaire-row {
      display: flex;

      .questionnaire-evtrav,
      .questionnaire-ld {
        .dt-box--column:nth-child(1) {
          margin-right: 8px;
        }
        .dt-box--column:nth-child(2) {
          margin-left: 8px;
        }
      }
      .questionnaire-ld {
        margin-left: 16px;
      }
      .questionnaire-evtrav {
        flex: 2;
        display: flex;
        flex-basis: 66.66%;
      }
      .questionnaire-ld {
        flex: 1;
        flex-basis: 33.33%;
      }
      @media screen and (max-width: 767px) {
        flex-direction: column;
        .questionnaire-evtrav {
          .dt-box--column:nth-child(2) {
            margin-top: 24px;
            margin-right: 8px;
            margin-left: 0px;
          }
        }
        .questionnaire-ld {
          .dt-box--column {
            margin-top: 24px;
          }
        }
        .questionnaire-evtrav,
        .questionnaire-ld {
          max-width: 100% !important;
        }
      }
      @media screen and (max-width: 1200px) {
        .questionnaire-evtrav {
          flex: 1 !important;
          flex-basis: 50% !important;
          max-width: 50%;
          flex-direction: column;
        }
        .questionnaire-ld {
          flex-basis: 50% !important;
          max-width: 50%;
        }
      }
      @media screen and (min-width: 1201px) {
        /* background: lightcoral; */
        .dt-box--column {
          /* margin: 0px !important; */
        }
        .questionnaire-evtrav {
          flex-basis: 66.66% !important;
          max-width: 66.66% !important;
          .dt-box--column {
            flex-basis: calc(50% - 8px) !important;
            max-width: calc(50% - 8px);
          }
        }
        .questionnaire-ld {
          flex-basis: 33.33% !important;
          max-width: 33.33% !important;
        }
      }
    }

    .exform-row {
      display: flex;

      .exform-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-right: 8px;
        margin-left: 8px;
      }

      @media screen and (max-width: 1200px) {
        .exform-column {
          flex: 1 !important;
          flex-basis: 50% !important;
          max-width: 50%;
        }
        .exform-column {
          flex-basis: 50% !important;
          max-width: 50%;
        }
      }
      @media screen and (max-width: 767px) {
        flex-direction: column;
        .exform-column {
          flex-basis: 100% !important;
          max-width: 100%;
          margin-top: 24px;
          margin-right: 8px;
          margin-left: 0px;
        }
      }
    }

    > .dt-box--row {
      min-height: 500px;
      transition: all 0.69s linear;
    }
    @media (max-width: 1023px) {
      .dt-box--row {
        flex-direction: column;
        flex-wrap: nowrap;
        /* background: plum; */
        .dt-box--column {
          flex-basis: 100% !important;
          &:nth-child(2) {
            max-width: 100% !important;
          }
        }
      }
    }

    @media (min-width: 1200px) {
      max-width: 1400px;
      .dt-box--row {
        .dt-box--column {
          max-width: 33.3333%;
        }
      }
    }
    @media (max-width: 1199px) {
      .dt-box--row {
        /* background: rgba(0, 191, 255, 0.458); */
        .dt-box--column {
          flex-basis: 50%;
          &:nth-child(2) {
            order: 3;
            max-width: 50%;
            .dt-modal--subtitle {
              margin-top: 15px !important;
            }
          }
        }
      }
    }
  }

  .dt-box--row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px;

    .dt-box--column {
      flex: 1;
      padding: 0 8px;
    }
  }

  .travel_before_list {
    max-height: 70px;
  }
  .travel_after_list {
    max-height: 150px;
  }
  .dt-ntable {
    --ntable-height: 150px;
  }

  .lock-wrap {
    display: flex;
    align-items: center;
    height: 42px;

    img {
      margin-left: -10px;
      width: 24px;
      height: 24px;
    }
    span {
      // min-width: 360px;
      font-size: 11px;
      line-height: 1;
      color: var(--text-5);
    }
  }
}
</style>

<style lang="scss" scoped>
.menu__content {
  border: none !important;
  box-shadow: none !important;
}
</style>
